import {
  LangResignBetterOpportunity,
  LangResignSalary,
  LangResignCareerGrowth,
  LangResignWorkLifeBalance,
  LangResignRelocation,
  LangResignHealth,
  LangResignFamily,
  LangResignPersonal,
  LangResignRetirement,
  LangContractEnd,
  LangTerminationPerformance,
  LangTerminationViolation,
  LangTerminationCompany,
  LangProbationFailed,
  LangWrongInput,
  LangOther
} from './languange';

// Opsi alasan resign untuk statistik turnover
export const RESIGNATION_REASONS = [
  { value: 'resign_better_opportunity', label: LangResignBetterOpportunity },
  { value: 'resign_salary', label: LangResignSalary },
  { value: 'resign_career_growth', label: LangResignCareerGrowth },
  { value: 'resign_work_life_balance', label: LangResignWorkLifeBalance },
  { value: 'resign_relocation', label: LangResignRelocation },
  { value: 'resign_health', label: LangResignHealth },
  { value: 'resign_family', label: LangResignFamily },
  { value: 'resign_personal', label: LangResignPersonal },
  { value: 'resign_retirement', label: LangResignRetirement },
  { value: 'contract_end', label: LangContractEnd },
  { value: 'termination_performance', label: LangTerminationPerformance },
  { value: 'termination_violation', label: LangTerminationViolation },
  { value: 'termination_company', label: LangTerminationCompany },
  { value: 'probation_failed', label: LangProbationFailed },
  { value: 'wrong_input', label: LangWrongInput },
  { value: 'other', label: LangOther },
]
